<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">Category</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Category</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toCategoryCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增分類</span>
      </button>
    </div>
    <!-- Table -->
    <CategoryTable></CategoryTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CategoryTable from '@/views/C-1__Category/c/CategoryTable.vue';

export default {
  components: {
    CategoryTable,
  },
  async created() {
    this.clear();
    await this.getCategories();
  },
  methods: {
    ...mapActions('category', {
      getCategories: 'find',
      clear: 'clear',
    }),
    toCategoryCreate() {
      this.$router.push({ name: 'CategoryCreate' });
    },
  },
};
</script>

<style></style>
